import {ErrorHandler, inject, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection, provideAppInitializer} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {PreloadAllModules, provideRouter, Router, RouteReuseStrategy, withPreloading} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {IonicStorageModule} from '@ionic/storage-angular';
import {MarkdownModule} from 'ngx-markdown';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {authInterceptor} from './app/Core/Interceptors/auth.interceptor';
import {I18nManagerService} from './app/Services/Shared/i18n-manager.service';
import {GlobalErrorHandler} from './app/Core/Handlers/global-error.handler';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {environment} from './environments/environment';
import packageJson from '@packageJson';
import * as Sentry from '@sentry/angular';

registerLocaleData(localeEs, 'es');

if (environment.production) {

  Sentry.init({
    dsn: 'https://eef26487d51d2a67ef9a6aabe333002a@sentry.yurest.dev/14',
    environment: 'production',
    release: `yurest_app@${packageJson.version}`,
    dist: packageJson.version,
    integrations: [Sentry.browserTracingIntegration({enableInp: true})],
    tracesSampleRate: 0.1,
  });

}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      IonicModule.forRoot({
        mode: 'ios',
        backButtonText: '',
        backButtonDefaultHref: '',
      }),
      IonicStorageModule.forRoot(),
      MarkdownModule.forRoot(),
    ),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      lang: 'es',
      fallbackLang: 'es',
    }),
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: Sentry.TraceService, deps: [Router]},
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      inject(I18nManagerService).bootstrapLanguage().catch(() => undefined);
    }),
  ],
}).catch((err) => console.log(err));
